<script>
  import { toJSDate } from "../../../../Controller/analytics/toJSDate";
  export let data = [];

  let collapsed = {};
  const toggle = (i) => (collapsed = { ...collapsed, [i]: !collapsed[i] });
</script>

{#each data as item, i}
  <div class="card comments">
    <button
      type="button"
      class="head"
      aria-expanded={!collapsed[i]}
      on:click={() => toggle(i)}
    >
      <span class="card-title">{item.pregunta}</span>
      <span class="count">{item.respuesta.length}</span>
      <svg class="chev" class:open={!collapsed[i]} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    {#if !collapsed[i]}
      <ul class="clist">
        {#each item.respuesta as resp}
          <li>
            <p class="text">{resp.respuesta}</p>
            <time class="when">
              {toJSDate(resp.date).toLocaleDateString()}
              {toJSDate(resp.date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
            </time>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
{/each}

<style>
  .comments + .comments {
    margin-top: 0.75rem;
  }

  .head {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    width: 100%;
    padding: 0.85rem 1.1rem;
    border: 0;
    background: transparent;
    text-align: left;
    color: inherit;
  }

  .head .card-title {
    flex: 1;
    min-width: 0;
  }

  .count {
    font-size: 0.75rem;
    font-weight: 700;
    color: #57543f;
    background: #e4ebce;
    border-radius: 999px;
    padding: 0.05rem 0.55rem;
  }

  .chev {
    width: 18px;
    height: 18px;
    flex: none;
    color: #57543f;
    transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  }

  .chev.open {
    transform: rotate(180deg);
  }

  .head:focus-visible {
    outline: 2px solid #ce5b34;
    outline-offset: -2px;
  }

  .clist {
    list-style: none;
    margin: 0;
    padding: 0 1.1rem 0.5rem;
  }

  .clist li {
    padding: 0.6rem 0;
    border-top: 1px solid rgba(44, 51, 32, 0.1);
  }

  .text {
    margin: 0;
    font-size: 0.9rem;
    overflow-wrap: anywhere;
  }

  .when {
    display: block;
    margin-top: 0.15rem;
    font-size: 0.75rem;
    color: #83805f;
  }

  @media (prefers-reduced-motion: reduce) {
    .chev {
      transition: none;
    }
  }
</style>
